export default __webpack_public_path__ + "static/media/bo.97ca7a63.png";